import { useMemo } from 'react';
import { useSelector } from 'js/store/hooks';
import { MAINTENANCE_MODE_REDUCER } from 'js/store/constants';

import * as helpers from './helpers';

export const useIsMaintenanceEnabled = () => {
    const maintenanceData = useSelector((state) => state[MAINTENANCE_MODE_REDUCER]);

    return useMemo(() => ({
        isMaintenanceModeEnabled: helpers.isMaintenanceModeEnabled(maintenanceData)
    }), [maintenanceData]);
};
